module.exports = __webpack_public_path__ + "2ffc848592af00d2e5d0fea7a35d8000.MP3";